import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { HEADER_ITEM_DEFAULT_LABEL } from '../../../constants/report-model-designer.constants';
import { modifyDate } from '../../../utils/report-model-designer-utils';

const useStyles = makeStyles({
  textContainer: {
    marginRight: 55,
    margin: 5,
    display: 'flex',
    alignItems: 'start',
    '@media (max-width: 1300px)': {
      marginRight: 15,
    },
  },
  textTitleContainer: {
    marginRight: 10,
  },
  textTitle: {
    fontFamily: 'Proxima Nova',
    fontSize: 14,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    color: 'var(--black)',
  },
  textTitleValue: {
    fontFamily: 'Proxima Nova',
    fontSize: 14,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    color: 'var(--black)',
    wordWrap: 'break-word',
    whiteSpace: 'pre-line',
    maxWidth: 505,
    minWidth: 80,
  },
});

const HeaderInfo = ({ modelInfo }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <>
      <div className={classes.textContainer}>
        <div className={classes.textTitleContainer}>
          <Typography className={classes.textTitle}>{translateString('Report Model:')}</Typography>
        </div>
        <div>
          <Typography className={classes.textTitleValue}>{modelInfo?.ReportModelName}</Typography>
        </div>
      </div>
      <div className={classes.textContainer}>
        <div className={classes.textTitleContainer}>
          <Typography className={classes.textTitle}>
            {translateString('Last Modified Date:')}
          </Typography>
        </div>
        <div>
          <Typography className={classes.textTitleValue}>
            {modifyDate(modelInfo?.ReportLastModified) ?? HEADER_ITEM_DEFAULT_LABEL}
          </Typography>
        </div>
      </div>
    </>
  );
};

export default HeaderInfo;
